<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title><span [innerHTML]="title | safeHTML"></span></h1>
    <div class="scroll" fxFlex fxLayout="column" fxLayoutAlign="start stretch">
        <p [innerHTML]="message | safeHTML"></p>
        <div *ngIf="ShowSearch">
            <form fxLayout="column" fxLayoutAlign="start start" [formGroup]="SearchForm" novalidate>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-sm="20px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <mat-form-field floatPlaceholder="never">
                        <input type="search" matInput formControlName="LastName" placeholder="Last Name" (keyup.enter)="HandleUserKey($event)" autofocus />
                    </mat-form-field>
                    <mat-form-field floatPlaceholder="never">
                        <input type="search" matInput formControlName="FirstName" placeholder="First Name" (keyup.enter)="HandleUserKey($event)" />
                    </mat-form-field>
                    <mat-form-field floatPlaceholder="never">
                        <input type="search" matInput formControlName="StudentID" placeholder="Student ID" (keyup.enter)="HandleUserKey($event)" />
                    </mat-form-field>
                    <mat-form-field floatPlaceholder="never">
                        <mat-select formControlName="Grade" placeholder="Grade Level">
                            <mat-option *ngFor="let grade of AvailableSchoolGrades" [value]="grade">{{grade}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="SearchForm.hasError('TooFewCharacters')"><em class="error">You must provide at least 5 characters combined between first name and last name search fields if you are not restricting by student ID or grade level.</em></div>
                <div *ngIf="SearchForm.hasError('noneprovided')"><em>You must provide at least 1 search field in order to conduct a student search.</em></div>
                <div fxLayout="row" fxLayoutAlign="center center" style="align-self:center">
                    <button type="button" color="primary" mat-raised-button (click)="HandleStudentSearch()" [disabled]="!SearchReady || SearchForm.invalid">Search</button>
                    <button type="button" color="warn" mat-raised-button style="margin-left:30px" (click)="SearchForm.reset()">Reset</button>
                </div>
            </form>
        </div>
        <div *ngIf="SmallDisplay && StudentSearchConducted" class="centered">
            <button type="button" color="primary" mat-raised-button (click)="ShowSearchForm()">Search Again</button>
        </div>
        <div [hidden]="StudentSearchConducted !== true" fxFlex>
            <mat-form-field floatPlaceholder="never" class="filter">
                <input matInput #filter placeholder="Filter results..." />
            </mat-form-field>
            <mat-table class="bordered" #table [dataSource]="StudentData" matSort>
                <ng-container matColumnDef="LastName">
                    <mat-header-cell *matHeaderCellDef class="centered">Last Name</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{user.LastName | titleCase}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="FirstName">
                    <mat-header-cell *matHeaderCellDef class="centered">First Name</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{user.FirstName | titleCase}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="StudentID">
                    <mat-header-cell *matHeaderCellDef class="centered">Student ID</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{user.StudentID}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="School">
                    <mat-header-cell *matHeaderCellDef class="centered">School</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{user.SchoolName}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Grade">
                    <mat-header-cell *matHeaderCellDef class="centered">Grade</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{user.GradeLevel}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">
                        <button mat-raised-button color="primary" (click)="OKHandler(user)">Select</button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="NoData">
                    <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
                    <mat-cell *matCellDef="let user"><em>No search results were found with the provided search criteria.</em></mat-cell>
                </ng-container>

                <ng-container matColumnDef="SmallDisplay">
                    <mat-header-cell *matHeaderCellDef>Search Result(s)</mat-header-cell>
                    <mat-cell *matCellDef="let user">
                        <div fxLayout="column" fxLayoutAlign="start stretch">
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>Last Name</form-label>
                                <div>{{user.LastName | titleCase}}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>First Name</form-label>
                                <div>{{user.FirstName | titleCase}}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>Student ID</form-label>
                                <div>{{user.StudentID}}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>School</form-label>
                                <div>{{user.SchoolName}}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>Grade</form-label>
                                <div>{{user.GradeLevel}}</div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start center">
                                <button mat-raised-button color="primary" (click)="OKHandler(user)">Select</button>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
                <mat-row *matRowDef="let row; columns: VisibleColumns"></mat-row>
            </mat-table>
            <div *ngIf="!StudentData.filtereddata || !StudentData.filtereddata.length"><em>No search results were found with the provided search criteria.</em></div>
            <mat-paginator #paginator [length]="StudentData.filtereddata.length" [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
    </div>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button color="warn" mat-raised-button (click)="CancelHandler()"><span [innerHTML]="canceltext | safeHTML"></span></button>
    </mat-dialog-actions>
</div>


// WEBPACK FOOTER //
// ./src/services/dialogs/studentsearch/studentsearch.dialogcomponent.html